/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type AvgSessionLengthFilterConfigColumn =
  (typeof AvgSessionLengthFilterConfigColumn)[keyof typeof AvgSessionLengthFilterConfigColumn];

export const AvgSessionLengthFilterConfigColumn = {
  avg_session_length: 'avg_session_length',
} as const;
